import httpClient from '../http/http-client';
import {
  IAddUserLocationPermission,
  IAddUserSubsidiaryPermission,
  IRemoveUserLocationPermission,
  IRemoveUserSubsidiaryPermission,
  IUserPermissionSummary,
  IUpdateUserAccessFlags,
} from './user-permission.model';

export default class UserPermissionService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async getByUser(userId: string): Promise<IUserPermissionSummary> {
    return this.http.get(`user-permission/user/${userId}`)
      .then((response) => response.data)
      .catch((err) => { console.log(err); throw err; });
  }

  async updateFlags(payload: IUpdateUserAccessFlags): Promise<any> {
    return this.http.patch(`user-permission/flags`, payload)
      .then((response) => response.data)
      .catch((err) => { console.log(err); throw err; });
  }

  async addLocation(payload: IAddUserLocationPermission): Promise<any> {
    return this.http.post(`user-permission/location`, payload)
      .then((response) => response.data)
      .catch((err) => { console.log(err); throw err; });
  }

  async removeLocation(payload: IRemoveUserLocationPermission): Promise<any> {
    // axios delete with body uses config.data
    return this.http.delete(`user-permission/location`, { data: payload })
      .then((response) => response.data)
      .catch((err) => { console.log(err); throw err; });
  }

  async addSubsidiary(payload: IAddUserSubsidiaryPermission): Promise<any> {
    return this.http.post(`user-permission/subsidiary`, payload)
      .then((response) => response.data)
      .catch((err) => { console.log(err); throw err; });
  }

  async removeSubsidiary(payload: IRemoveUserSubsidiaryPermission): Promise<any> {
    return this.http.delete(`user-permission/subsidiary`, { data: payload })
      .then((response) => response.data)
      .catch((err) => { console.log(err); throw err; });
  }
}

